import React, { useEffect, useContext, useState, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';

function ModalDifferentParent() {
  const { t } = useTranslation();

  const {
    adoptedTicket,
    parentInfo,
    updateAdoptedTicket,
    session,
    updateFocusOnMainScreen,
    userInfo,
    operator,
    hall,
    openSessionTerminal,
    updateOpenSessionTerminal,
    updateShowModalDifferentParent,
    updateTransactionsArray,
    updateIsLoadingScreen,
  } = useContext(AppContext);

  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);

  const hallRef = useRef(hall);
  useEffect(() => {
    hallRef.current = hall;
  }, [hall]);

  const operatorRef = useRef(operator);
  useEffect(() => {
    operatorRef.current = operator;
  }, [operator]);

  const sessionRef = useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const adoptedTicketRef = useRef(adoptedTicket);
  useEffect(() => {
    adoptedTicketRef.current = adoptedTicket;
  }, [adoptedTicket]);

  const [isTerminalBusy, setIsTerminalBusy] = useState(false);

  useEffect(() => {
    //console.log('adoptedTicket', adoptedTicket);
  }, [adoptedTicket]);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const handleCashout = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        setIsTerminalBusy(false);
        //deleteTransactions(transactions[transactions.length - 1]);
        return;
      }

      updateTransactionsArray([
        {
          name: 'Utbetaling - CH',
          //amount: parseInt(amount),
          amount: data.amount * -1,
          type: 'transaction',
          ticketData: data,
        },
      ]);

      if (parentInfoRef.current) {
        socket.emit('checkLimitStatus', {
          userInfo: parentInfoRef.current,
          bingoName: hallRef.current,
        });
      } else {
        socket.emit('checkLimitStatus', {
          userInfo: userInfoRef.current,
          bingoName: hallRef.current,
        });
      }
      setTimeout(() => {
        setIsTerminalBusy(false);
        updateFocusOnMainScreen(true);
        cancel();
      }, 300);
    };

    socket.on('cashoutTicketAdopted', handleCashout);

    return () => {
      socket.off('cashoutTicketAdopted', handleCashout);
    };
  }, [socket]);

  //* CONFIRM REGISTRATION BUTTON (search if phone exist or register the user)
  const handlePayout = async () => {
    if (isTerminalBusy) {
      return;
    }
    updateFocusOnMainScreen(true);

    setIsTerminalBusy(true);

    var dataNewTicket = {
      name: 'Utbetaling - CH',
      amount: parseInt(adoptedTicket.ticket.balances.wallet),
      type: 'transaction',
    };

    var data = {
      transactions: [],
      operator: operatorRef.current,
      bingoName: hallRef.current,
      sessionID: sessionRef.current,
      provider: 'CH',
      description: 'Utbetaling',
      amount: parseInt(adoptedTicketRef.current.ticket.balances.wallet),
      user7Pincode: adoptedTicketRef.current.parent.user7pincode,
      userInfo: adoptedTicketRef.current.parent.userInfo,
      isChild: true,
      usePrinter: false,
      useSMS: false,
      printBarcode: false,
      qrMessage: false,
      session: sessionRef.current,
      playerID: adoptedTicketRef.current.ticket.id,
      cashoutType: 'cash_from_wallet',
      ticketID: adoptedTicketRef.current.ticket.id,
      ticketUsername: adoptedTicketRef.current.ticket.username,
      ticket7Pincode: adoptedTicketRef.current.ticket['7 digit PIN'],
      adoptedParent: parentInfoRef.current
        ? parentInfoRef.current
        : userInfoRef.current,

      action: 'cashoutTicketAdopted',
    };

    data.transactions.push(dataNewTicket);
    updateIsLoadingScreen(true);
    socket.emit('cashoutTicketAdopted', data);
  };

  const cancel = async () => {
    updateOpenSessionTerminal(false);
    updateAdoptedTicket({});
    updateFocusOnMainScreen(true);
    updateShowModalDifferentParent(false);
  };

  const getTerminalNumber = (ip) => {
    const parts = ip.split('.');
    const lastPart = parts[parts.length - 1];
    return lastPart;
  };

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body" style={{ width: '1000px' }}>
            <h1>{t('sales.ticketWithDifferentParentTitle')} </h1>
            <p>{t('sales.ticketWithDifferentParentText')}</p>
            <p>
              {t('sales.currentSaldo')}:{' '}
              <span
                style={{
                  fontSize: '22px',
                  color: '#42a5f5',
                  fontWeight: 'bold',
                }}
              >
                {adoptedTicket.ticket.balances.wallet + ' kr.'}
              </span>
            </p>

            {openSessionTerminal && (
              <p>
                {t('sales.openSessionText1')}
                <span
                  style={{
                    fontSize: '22px',
                    color: '#42a5f5',
                    fontWeight: 'bold',
                  }}
                >
                  {getTerminalNumber(openSessionTerminal.terminalIP)}
                </span>
                {t('sales.openSessionText2')}
                <span
                  style={{
                    fontSize: '22px',
                    color: '#42a5f5',
                    fontWeight: 'bold',
                  }}
                >
                  {' '}
                  {openSessionTerminal.saldo}
                </span>
                {' NOK'}
              </p>
            )}

            <div
              className="react-confirm-alert-button-group"
              style={{ marginTop: '55px' }}
            >
              {!openSessionTerminal && (
                <button
                  className="btn-custom-yes"
                  onClick={() => {
                    if (adoptedTicket.ticket.balances.wallet === 0) {
                      return;
                    }
                    handlePayout();
                  }}
                  style={{
                    display: 'flex',
                    opacity:
                      adoptedTicket.ticket.balances.wallet < 1 ? '0.3' : 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px', // Space between icon and text
                  }}
                >
                  <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                  {t('sales.confirm')}
                </button>
              )}

              <button
                className="btn-custom-no"
                onClick={() => {
                  cancel();
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px', // Space between icon and text
                }}
              >
                <CancelIcon style={{ fontSize: '1.2em' }} />

                {t('sales.cancel')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalDifferentParent;
